import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import ModalDocumentInstructions from '~/components/ModalDocumentInstructions';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { DOC_TYPES, base64ToBlob, useStores } from '~/utils';
import OnboardingDocPhotoFront from './OnboardingDocPhotoFront';

const OnboardingDocPhotoFrontContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleDocumentSelection = (docType: DOC_TYPES) => {
    user.setSelectedDocumentType(docType);
    setIsModalOpen(false);
  };

  const handleSubmit = async (image: string) => {
    const blob = base64ToBlob(image);
    const picture = {
      uri: image,
      name: `${uuid()}.jpg`,
      mimeType: 'image/jpeg',
      type: user.selectedDocumentType!,
      size: blob.size,
      blob: blob,
    };

    await user.userImageValidation(picture);
    navigate(Routes.ONBOARDING_DOC_PHOTO_BACK);
  };

  return (
    <>
      <OnboardingDocPhotoFront handleSubmit={handleSubmit} />
      <ModalDocumentInstructions
        isOpen={isModalOpen}
        handleDocumentSelection={handleDocumentSelection}
      />
    </>
  );
};

export default observer(OnboardingDocPhotoFrontContainer);
